import React from "react";
import { OvsTypeCard, OvsTypeSection } from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData, storyblokEditable } from "@storyblok/react";
import Image from "next/image";
import { renderRichText } from "@/lib/richText";

interface OvsTypeSectionProps {
  blok?: OvsTypeSection & SbBlokData;
}

const OvsTypeSectionComponent: React.FC<OvsTypeSectionProps> = ({ blok }) => {
  if (!blok) return null;

  const { type, title, types, subtitle } = blok;

  // Set background and container classes based on type
  const bgClass = type === 'asvs' ? 'bg-light' : 'bg-white';
  const containerClass = `crest-ovs-${type === 'asvs' ? 'apps' : 'mobile'}-container`;

  return (
    <div
      {...storyblokEditable(blok)}
      className={`${bgClass} ${containerClass} component-cards-content py-4 py-md-5`}
    >
      <div className="container">
        <h2 className="col-24 text-center mb-5 text-secondary">
          {title}
        </h2>
        {subtitle && (
          <div
            className="text-center mb-4"
            dangerouslySetInnerHTML={{ __html: renderRichText(subtitle) }}
          />
        )}
      </div>

      <div className="container row row-cols-1 row-cols-xl-4 justify-content-center g-lg-4 mx-auto">
        {types?.map((card, index) => (
          <div key={card._uid} {...storyblokEditable(card as OvsTypeCard & SbBlokData)} className="col mb-3 text-center">
          {index === 0 ? (
              // First card with icon
              <div className={`card card-lighter overflow-hidden h-100 crest-ovs-${type === 'asvs' ? 'apps' : 'mobile'}`}>
                <div className="p-4">
                  {card.icon?.filename && (
                    <Image
                      src={card.icon.filename}
                      width={120}
                      height={120}
                      alt={card.title || ''}
                      className="img-fluid mb-2 mx-auto component-cards-content-icon"
                    />
                  )}
                  <h3 className="mt-2 text-secondary">{card.title}</h3>
                  <p>
                    {typeof card.description === 'string'
                      ? card.description
                      : renderRichText(card.description)}
                  </p>
                </div>
              </div>
            ) : (
              // Other cards
              <div className="card card-lighter overflow-hidden h-100">
                <div className="p-4">
                  <h3 className="mt-2 text-secondary">
                    {card.title}
                    {card.subtitle && (
                      <span className="d-block text-muted">{card.subtitle}</span>
                    )}
                  </h3>
                  <p>
                    {typeof card.description === 'string'
                      ? card.description
                      : renderRichText(card.description)}
                  </p>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default OvsTypeSectionComponent;